export default "__VITE_ASSET__DAzlvnzp__"